import React from "react";
import Container from "react-bootstrap/Container";
import CreateTimeEntry from "../CreateTimeEntry";
import {ParentContainerStyle} from "../../types";


const CreateDriverTimeEntryPage: React.FC = () => {
    return(
        <Container fluid style={ParentContainerStyle}>
            <CreateTimeEntry renderDriver={true}/>
        </Container>
    )
}


export default CreateDriverTimeEntryPage